import React from "react";
import { TextField } from "@mui/material";

export default function TextBox({ value, onChange, label, type, bool, disabled }) {
  return (
    <div className="text-[14px] text-[#1E222B] leading-[150%]">
      <label className=" block mb-2 ">{label}</label>
      <TextField
        id="outlined-basic"
        variant="outlined"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
        type={type}
        disabled={disabled}
        className=" w-full bg-[#FAFBFC] rounded-md p-px"
      />
    </div>
  );
}
